
const addonsApi = ({ apiClient }) => ({
  list(id, params = {}, configs = {}) {
    return apiClient.get('/addons/', configs)
  },

  show(id, params = {}, configs = {}) {
    return apiClient.get(`/addons/${id}`, configs)
  },

  update(id, data, configs = {}) {
    return apiClient.put(`/addons/${id}`, data, configs)
  },

})

export default addonsApi
